export const isCorrectFieldLength = (fieldValue, length) => fieldValue?.trim() !== '' && fieldValue.length > length;

export const isValidEmailField = (fieldValue) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(fieldValue).toLowerCase());
};
